import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'

import { BusinessRoute } from '@/constants/paths'
import {
  BankEligibility,
  BankEligibilityDocumentState,
} from '@/domains/Business/types'
import { getImage } from '@/lib/images'
import { StatusBadge } from '@/shared/components'
import { ChevronRight } from '@/shared/icons/outline'
import { Button, Card, Typography } from '@/shared/ui'

type Props = {
  bankEligibility?: BankEligibility
}

export const HomeEURCBanner = ({ bankEligibility }: Props) => {
  const getTitleByState = () => {
    switch (bankEligibility?.currentStepDetails.state) {
      case BankEligibilityDocumentState.NOT_STARTED:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.title"
            defaultMessage="EURO payments are here!"
          />
        )

      case BankEligibilityDocumentState.IN_PROGRESS:
      case BankEligibilityDocumentState.COMPLETED:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.inProgress.title"
            defaultMessage="You've almost got EURO!"
          />
        )

      default:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.title"
            defaultMessage="EURO payments are here!"
          />
        )
    }
  }

  const getSubtitleByState = () => {
    switch (bankEligibility?.currentStepDetails.state) {
      case BankEligibilityDocumentState.IN_PROGRESS:
      case BankEligibilityDocumentState.COMPLETED:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.inProgress.subtitle"
            defaultMessage="We just need some more information, will take a minute or two"
          />
        )

      case BankEligibilityDocumentState.NOT_STARTED:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.subtitle"
            defaultMessage="Pay and get paid instantly in Europe at the best exchange rate for EURc"
          />
        )

      default:
        return (
          <FormattedMessage
            id="dashboard.eurc.banner.subtitle"
            defaultMessage="Pay and get paid instantly in Europe at the best exchange rate for EURc"
          />
        )
    }
  }

  const getCTAByState = () => {
    switch (bankEligibility?.currentStepDetails.state) {
      case BankEligibilityDocumentState.IN_PROGRESS:
      case BankEligibilityDocumentState.COMPLETED:
        return (
          <FormattedMessage
            id="action.finishApplication"
            defaultMessage="Finish application"
          />
        )
      default:
        return (
          <FormattedMessage
            id="action.getEuroPayments"
            defaultMessage="Get EURO payments"
          />
        )
    }
  }

  return (
    <Card
      size="large"
      className="bg-neutral-gray-50 relative flex flex-col overflow-hidden"
    >
      <div className="flex items-center gap-3">
        <div className="hidden h-36 w-42 shrink-0 lg:flex">
          <img
            src={getImage({ name: 'phone-map' })}
            alt=""
            aria-hidden
            className="absolute bottom-0 left-0 size-48 object-contain"
          />
        </div>

        <div className="flex h-full flex-col gap-3">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-3">
              <Typography bold>{getTitleByState()}</Typography>

              <StatusBadge
                className="uppercase"
                variant="active"
                title={<FormattedMessage id="label.new" defaultMessage="New" />}
              />
            </div>
            <Typography variant="body-small" className="text-neutral-gray-600">
              {getSubtitleByState()}
            </Typography>
          </div>

          <Button
            rightIcon={<ChevronRight />}
            className="mt-auto self-end"
            asChild
          >
            <Link to={BusinessRoute.KYB}>{getCTAByState()}</Link>
          </Button>
        </div>
      </div>
    </Card>
  )
}
